import { Box, Hidden } from "@mui/material"
import { useStyles } from "./styles"
import { DetailVisitState, ResendState } from "./type"
import { BreadCrumb, SnackSimple } from "../../../../components"
import { VisitList } from "./components/visitList"
import { createRef, useEffect, useState } from "react"
import { DetailVisit } from "./components/detailVisit"
import { VisitData, VisitProps } from "./components/visite/type"
import { BosySecton } from "./components/bodySection"
import { CustomPaper } from "../../../../components/CustomPaper"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { actionPlanFetch, scheduleServiceFetch, userGroupServiceFetch } from "../../../../utils/constants/callService"
import { formatResponse, formatScheduleByQuestionnaireResponse } from "./methods/formatResponse"
import { ModalState, VisitListData } from "./components/visitList/types"
import { useTranslation } from "react-i18next"
import { BodySection } from "./components/bodySection/types"
import { detailVisit, listPaths } from "./constants"
import { Resend } from "../../../../components/resend"
import { Status, Types } from "../../../../utils/enums"
import { Item, ObjectGeneric } from "../../../../utils/types/generals"
import { resendReportTypes } from "../main/constants/typeResendReport"
import { SubmitResendReport } from "../main/types"
import { handleAllErrors } from "../../../../utils/methods/handleErrors"
import { ResendRef } from "../../../../components/resend/types"
import { SectionProps } from "./components/section/types"
import { NoResponse } from "../../../../components/errors/noResponse"
import Loader from "../../../../components/loader"
import { DataFlag } from "../../../../utils/enums/dataExistence"
import { useQuery } from "@tanstack/react-query"
import { EventQuery } from "../../../../hooks/emitter/types"
import { useScheduleContext } from "../../context"

type LogbookPrefilters = { storeId?: string }

type LogbookNavState = {
  activityName?: string
  assignedQuestionnaireId?: string | number
}

function Detail() {
  const ref = createRef<ResendRef>()
  const location = useLocation()
  const { id } = useParams()
  const navigation = useNavigate()
  const styles = useStyles()
  const { t } = useTranslation()

  const navState = (location.state ?? {}) as LogbookNavState
  const activityNameFromState = (navState.activityName ?? "").trim()
  const idQuestionarie = navState.assignedQuestionnaireId != null ? Number(navState.assignedQuestionnaireId) : undefined

  const { idQuestionnaire, setIdQuestionnaire } = useScheduleContext()

  const [detail, setDetail] = useState<DetailVisitState>()
  const [visitList, setVisitList] = useState<VisitListData>({
    from: "",
    to: "",
    reportUrl: null,
    visitList: [],
  })
  const [bodySection, setBodySection] = useState<BodySection>()
  const [questions, setQuestions] = useState<Array<SectionProps>>()
  const [errorsResend, setErrorsResend] = useState<string[]>([])
  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    message: "",
    type: Types.SUCCESS as string,
  })
  const [modal, setModal] = useState<ModalState>({
    loading: false,
    open: false,
    title: "",
  })
  const [resend, setResend] = useState<ResendState>()
  const [logbookPrefilters, setLogbookPrefilters] = useState<LogbookPrefilters>({})
  const [createUserId, setCreateUserId] = useState<string | number | null>(null)
  const [presetDestination, setPresetDestination] = useState<any>(null)
  const [assignedQuestionnaireIds, setAssignedQuestionnaireIds] = useState<string | undefined>(undefined)
  const [hasActivities, setHasActivities] = useState<boolean | undefined>(undefined)
  const [questionnaireName, setQuestionnaireName] = useState<string | undefined>(undefined)
  const [scheduleId, setScheduleId] = useState<string | number | undefined>(undefined)

  const searchParams = new URLSearchParams(location.search)
  const idFolio = searchParams.get("idFolio")
  const [dataFlag, setDataFlag] = useState<DataFlag>(DataFlag.LOADING)

  useQuery({
    queryKey: [EventQuery.unit_schedule],
    queryFn: () => {
      getDetailById()
      return false
    },
    initialData: false,
    enabled: !!id,
    refetchOnWindowFocus: false,
  })

  const seeDetail: VisitProps["seeDetail"] = ({ id: localeId, visitListExternal }) => {
    const list = visitListExternal || visitList.visitList
    const visitFound = list?.find((item) => item.id == localeId)

    if (visitFound?.report) visitFound.report.type = 2

    setDetail({ preview: true, visitData: visitFound })
    setBodySection((prev) => {
      if (!prev) return undefined
      return {
        ...prev,
        reportData: {
          infoReport: visitFound?.infoReport,
          lastReport: visitFound?.lastReport,
          report: visitFound?.report,
        },
        questionId: localeId,
        status: visitFound?.status ?? Status.INCOMPLETE,
      }
    })
    getQuestionarieById({ localeId, visitData: visitFound })
    setQuestions([])
  }

  const goList = () => {
    navigation("/dashboard/calendar")
  }

  const seeList = () => {
    setDetail({ preview: false })
    setBodySection((prev) => {
      if (!prev) return undefined
      return {
        ...prev,
        reportData: {
          report: {
            date: visitList.from,
            url: visitList.reportUrl,
            type: 1,
          },
        },
        status: Status.INCOMPLETE,
      }
    })
  }

  const buildPresetDestinationFromResponse = (response: any) => {
    const store = response?.store
    if (!store?.id) return null

    return {
      id: store.id,
      name: store.name ?? "",
      latitude: store.latitude ?? store.lat ?? "",
      longitude: store.longitude ?? store.lng ?? "",
      type: store.type ?? "UNITY",
      timeZone: store.timeZone ?? store.timezone ?? null,
      store,
    }
  }

  const buildAssignedQuestionnaireIds = (response: any): string | undefined => {
    const ids = (response?.assignedQuestionnaires ?? [])
      .map((it: any) => it?.id)
      .filter((x: any) => x !== null && x !== undefined)
      .map((x: any) => String(x))

    return ids.length ? ids.join(",") : undefined
  }

  const getDetailById = async () => {
    if (!id) return
    setScheduleId(id)
    setDataFlag(DataFlag.LOADING)

    const idDetail = location?.state?.replaceRoutes?.schedule_state?.state?.id ?? (location as any)?.state?.id

    const response = await scheduleServiceFetch.getScheduleById(
      id,
      idQuestionarie ? idQuestionarie : Number(idQuestionnaire)
    )

    if (!response?.errors) {
      setCreateUserId(response.userAssign?.id?.toString?.() ?? response.userAssign?.id ?? null)
      setLogbookPrefilters({ storeId: response?.store?.id?.toString?.() ?? response?.store?.id })
      setPresetDestination(buildPresetDestinationFromResponse(response))
      setAssignedQuestionnaireIds(buildAssignedQuestionnaireIds(response))
      setHasActivities(Boolean(response?.hasActivities))
      setQuestionnaireName(
        response?.assignedQuestionnaires?.find((q: any) => q?.questionnaireMainData?.name)?.questionnaireMainData?.name
      )

      const { visitList, bodySection } = formatResponse({ response, t })
      setVisitList(visitList)
      setDataFlag(DataFlag.DATA)
      setBodySection(bodySection)

      if (idDetail) {
        seeDetail({ id: idDetail, visitListExternal: visitList.visitList })
      }
    } else {
      setDataFlag(DataFlag.NODATA)
    }
  }

  const getQuestionarieById = async ({
    localeId,
    visitData,
  }: {
    localeId: string | number
    visitData?: VisitData
  }) => {
    if (id) {
      const response = await scheduleServiceFetch.getQuestionarieById(localeId)
      setQuestions(
        formatScheduleByQuestionnaireResponse({
          response,
          id: localeId,
          header: {
            title: visitData?.title ?? "",
            parentId: visitData?.detailVersion?.parentId || null,
            version: visitData?.detailVersion?.version || "1",
          },
        })
      )
    }
  }

  const openResend = (payload?: ResendState) => {
    setModal((prev) => ({ ...prev, open: true }))
    setResend(payload)
  }

  const closeModal = () => {
    setErrorsResend([])
    setModal({ loading: false, open: false, title: "" })
    ref.current?.clearData()
  }

  const submitResendReport = async ({ id, data, questionnaireOption, type }: SubmitResendReport) => {
    const clearData = ref.current?.clearData
    setModal((prev) => ({ ...prev, loading: true }))

    const emails = data?.externalEmails?.split(",")?.filter((item: string) => !!item)

    let body: ObjectGeneric = {
      user_assign: !!data?.user_assign,
      users_supervisors: !!data?.users_supervisors,
      users_store: !!data?.users_store,
      user_manage_store: !!data?.user_manage_store,
      email_store: !!data?.email_store,
      type: type ?? resendReportTypes.report,
    }

    if (!!emails?.length) body["external_emails"] = emails

    const localeId = questionnaireOption?.id ?? id
    const endpointResend = questionnaireOption?.id ? actionPlanFetch.sendReportQuestionnaire : actionPlanFetch.sendReport

    const response = await endpointResend(localeId, body)

    setModal((prev) => ({ ...prev, loading: false }))

    if (!response?.errors) {
      closeModal()
      setOpenSnackbar({
        open: true,
        type: Types.SUCCESS,
        message: t("general.reportSuccess"),
      })
      if (clearData) clearData()
      return
    }

    if (["00", "01", "02"].includes(response.code)) {
      if (response.code == "00") {
        closeModal()
        setOpenSnackbar({
          open: true,
          type: Types.SUCCESS,
          message: t("general.reportSuccess"),
        })
        return
      }

      if (response.code == "01") {
        let listErrors: string[] = []

        if (response.data?.userAssign) listErrors.push(t(`reportFolio.modal.sendReport.userWhoResponded`))
        if (response.data?.usersSupervisors) listErrors.push(t(`reportFolio.modal.sendReport.userSupervisor`))
        if (response.data?.usersStore) listErrors.push(t(`reportFolio.modal.sendReport.userStore`))
        if (response.data?.userManageStore) listErrors.push(t(`reportFolio.modal.sendReport.agentStore`))
        if (response.data?.emailStore) listErrors.push(t(`reportFolio.modal.sendReport.emailStore`))
        if (!!response.data?.externalEmails?.length)
          listErrors.push(`${t(`reportFolio.modal.sendReport.externalEmails`)}: ${response.data?.externalEmails?.join(", ")}`)

        setErrorsResend(listErrors)
        return
      }

      if (response.code == "02") {
        setOpenSnackbar({
          open: true,
          type: Types.ERROR,
          message: t("general.reportError"),
        })
        return
      }

      return
    }

    if (!!response.errors) {
      setOpenSnackbar({
        open: true,
        type: Types.ERROR,
        message: handleAllErrors(response?.errors[0].code, t, t("general.reportError")),
      })
    }
  }

  const saveReportUrl = ({ url }: { url: string }) => {
    setBodySection((prev) => ({
      ...prev,
      reportData: {
        ...(prev?.reportData ?? {}),
        report: {
          ...(prev?.reportData?.report ?? {}),
          url,
        },
      },
    }))
  }

  const closeSnackbar = () => {
    setOpenSnackbar((prev) => ({ ...prev, open: false }))
  }

  const getFolioBreadcrumbs = () => [
    {
      id: "maintenanceRequest",
      label: "maintenanceRequest",
      navigate: () => {
        navigation(`/dashboard/report-folio/dashboard`)
      },
    },
    {
      id: "detailReportFolio",
      label: "detailReportFolio",
      navigate: () => {
        navigation(`/dashboard/report-folio/dashboard/detail/${idFolio}`)
      },
    },
    {
      id: "scheduleList",
      label: "scheduleList",
      navigate: () => {},
    },
  ]

  const getDefaultBreadcrumbs = () => {
    if (detail?.preview) return detailVisit({ seeList, goList })
    return listPaths({ goList })
  }

  const assignedIdsForLogbook =
    assignedQuestionnaireIds ??
    (navState.assignedQuestionnaireId != null ? String(navState.assignedQuestionnaireId) : undefined)

  const getLogbookBreadcrumbs = () => [
    {
      id: "logbook",
      label: "logbookWithname",
      labelParams: { name: activityNameFromState },
      active: false,
      path: "/dashboard/logbook",
      navigate: () =>
        navigation("/dashboard/logbook", {}),
    },
    {
      id: "scheduleList",
      label: "scheduleList",
      active: true,
      path: `/dashboard/calendar/detail/${id}`,
      navigate: () => {},
    },
  ]

  const getBreadcrumbConfig = () => {
    if (activityNameFromState) {
      return {
        breadList: getLogbookBreadcrumbs(),
        notAddPath: true,
        removeBreadcrumb: ["report-folio", "calendar", "schedule-user"],
      }
    }

    if (idFolio) {
      return {
        breadList: getFolioBreadcrumbs(),
        removeBreadcrumb: ["report-folio", "calendar"],
        replaceLabels: {
          dashboard: "maintenanceRequest",
          scheduleDetail: "reportFolioDetail",
          detail: "visitDetail",
        },
      }
    }

    return {
      breadList: getDefaultBreadcrumbs(),
      removeBreadcrumb: (location.state as any)?.removeBreadcrumb || ["report-folio", "calendar", "schedule-user"],
      replaceLabels: (location.state as any)?.replaceLabels || {
        dashboard: "maintenanceRequest",
        detailEdit: "detailReportFolio",
      },
    }
  }

  useEffect(() => {
    if (idQuestionarie) {
      setIdQuestionnaire(idQuestionarie)
    }
  }, [idQuestionarie, setIdQuestionnaire])

  return (
    <Box sx={styles.body({ detail: !!detail?.preview, existData: !!bodySection })}>
      <Box sx={styles.container}>
        <BreadCrumb {...getBreadcrumbConfig()} />

        {dataFlag === DataFlag.NODATA && <NoResponse label={t("reportFolio.detail.general.noInformation")} />}
        {dataFlag === DataFlag.LOADING && <Loader />}

        {dataFlag === DataFlag.DATA && (
          <>
            {(!detail?.preview || (detail?.preview && idFolio)) && bodySection && (
              <VisitList
                isStore
                bodySection={{ ...bodySection, sendReport: openResend }}
                seeDetail={seeDetail}
                {...visitList}
              />
            )}

            {detail?.preview && detail.visitData && bodySection && (
              <DetailVisit
                saveReportUrl={saveReportUrl}
                isStore
                isScheduleUnity
                bodySection={{ ...bodySection, sendReport: openResend }}
                data={detail.visitData}
                questionsData={questions}
                visitList={visitList.visitList}
                seeDetail={seeDetail}
                scheduleId={scheduleId}
                logbookPrefilters={logbookPrefilters}
                presetDestination={presetDestination}
                createUserId={createUserId}
                assignedQuestionnaireIds={assignedQuestionnaireIds}
                hasActivities={hasActivities}
                questionnaireName={questionnaireName}
              />
            )}
          </>
        )}
      </Box>

      {bodySection && (
        <Hidden xlDown>
          <CustomPaper sx={styles.detail} elevation={2}>
            <BosySecton {...bodySection} saveReportUrl={saveReportUrl} sendReport={openResend} />
          </CustomPaper>
        </Hidden>
      )}

      <Resend
        ref={ref}
        close={closeModal}
        errorsResend={errorsResend}
        setErrorsResend={setErrorsResend}
        loading={!!modal?.loading}
        open={!!modal?.open}
        send={({ data }) => {
          if (id) submitResendReport({ data, id, questionnaireOption: (resend as any)?.queston, type: resend?.type })
        }}
        title={modal?.title ?? ""}
      />

      <SnackSimple close={closeSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
    </Box>
  )
}

export default Detail
